
export default {
  name: 'contact',
  components: {},
  props: [],
  data () {
    return {
      name: null,
      email: null,
      text: null
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    sendContact() {
      this.name = null;
      this.email =null;
      this.text = null;
    }
  }
}


